(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util"), require("@bingads-webui/odata-converter"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities", "@bingads-webui/http-util", "@bingads-webui/url-util", "@bingads-webui/odata-converter"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util"), require("@bingads-webui/odata-converter")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["@bingads-webui/http-util"], root["@bingads-webui/url-util"], root["@bingads-webui/odata-converter"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__40__, __WEBPACK_EXTERNAL_MODULE__123__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 124);
/******/ })
/************************************************************************/
/******/ ({

/***/ 123:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__123__;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(125);


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ODataBaseAdapter", {
  enumerable: true,
  get: function get() {
    return _index.ODataBaseAdapter;
  }
});

var _index = __webpack_require__(126);

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ODataBaseAdapter = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _httpUtil = __webpack_require__(39);

var url = _interopRequireWildcard(__webpack_require__(40));

var _primitiveUtilities = __webpack_require__(8);

var _odataConverter = __webpack_require__(123);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function sendBatchRequest(definition, params, options) {
  var reqs = _underscore.default.map(params, function (param) {
    var id = param.Id;

    var uri = _odataConverter.odataUri.convert({
      definition: definition,
      options: options,
      id: id
    });

    return {
      type: options.action,
      url: uri,
      data: param
    };
  });

  return _httpUtil.odata.batch({
    reqs: reqs,
    path: options.path
  }).then(function (response) {
    if (_underscore.default.isFunction(options.processResponse)) {
      options.processResponse(response);
    }

    return response;
  });
}

function getCommonOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ajaxOptions = _ref.ajaxOptions,
      ajaxOptions = _ref$ajaxOptions === void 0 ? {} : _ref$ajaxOptions,
      urlParameters = _ref.urlParameters,
      host = _ref.host,
      path = _ref.path,
      headers = _ref.headers,
      successCallback = _ref.successCallback,
      state = _ref.state,
      oDataToken = _ref.oDataToken;

  var options = _underscore.default.defaults({}, ajaxOptions);

  if (_underscore.default.isObject(urlParameters)) {
    options.urlParameters = urlParameters;
  }

  if (host) {
    options.host = host;
  }

  if (path) {
    options.path = path;
  }

  if (oDataToken) {
    options.oDataToken = oDataToken;
  }

  if (headers) {
    options.headers = headers;
  } // <TODO> [lizho] Remove this after related OData APIs are refactored.
  // This callback is to get response header for product offer/product group related OData APIs.


  if (_underscore.default.isFunction(successCallback)) {
    options.success = successCallback;
  } // <TODO>


  if (state) {
    options.params = _underscore.default.clone(state.attributes);
  }

  return options;
}

var ODataBaseAdapter =
/*#__PURE__*/
function () {
  // All of the methods shown here must return a promise
  // "definition" is a resource defintion that would
  // be returned by DS#defineResource
  // "options" would be the options argument that
  // was passed into the DS method that is calling
  // the adapter method
  function ODataBaseAdapter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ODataBaseAdapter);

    this.options = options;
  }

  _createClass(ODataBaseAdapter, [{
    key: "convertQuery",
    value: function convertQuery(queryParameters) {
      return _odataConverter.odataQuery.convert(queryParameters);
    }
  }, {
    key: "create",
    value: function create(definition, attrs, options) {
      _underscore.default.extendOwn(options, this.options);

      var data = _odataConverter.odataCast.data({
        data: attrs,
        definition: definition,
        options: options
      });

      var urlParameters = options.urlParameters; // Below if block is for the calls being made without EDM models
      // This enables making "POST" calls with query parameters without edm.

      if (attrs.queryParams) {
        urlParameters = this.convertQuery(attrs.queryParams);
        data = _underscore.default.omit(data, 'queryParams');
      } // Must resolve the promise with the created item
      // NOTICE: added ajaxOptions here.


      return _httpUtil.odata.post(_odataConverter.odataUri.convert({
        definition: definition,
        options: options
      }), _underscore.default.defaults({
        data: data,
        urlParameters: urlParameters
      }, getCommonOptions(options)));
    }
  }, {
    key: "find",
    value: function find(definition, id, options) {
      _underscore.default.extendOwn(options, this.options);

      var params = {};
      var queryParameters = options.queryParameters;

      if (_underscore.default.isObject(queryParameters)) {
        params = {
          data: _underscore.default.omit(this.convertQuery(queryParameters), '$top', '$count')
        };
      }

      params.path = options.path; // Must resolve the promise with the found item

      return _httpUtil.odata.get(_odataConverter.odataUri.convert({
        definition: definition,
        options: options,
        id: id,
        isFinding: true
      }), _underscore.default.defaults(params, getCommonOptions(options)));
    }
  }, {
    key: "findAll",
    value: function findAll(definition, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Must resolve the promise with the found items
      _underscore.default.extendOwn(options, this.options);

      var filterOptions = options.filterOptions; // params.entitySet is flavored. options.entitySet is only surported for backward support.

      var queryEntitySet = (0, _primitiveUtilities.get)(params, 'query.entitySet');
      var entitySet = options.edmRootResourceIdentifier && queryEntitySet ? options.edmRootResourceIdentifier.identifyEntitySet(queryEntitySet) : (0, _primitiveUtilities.get)(options, 'entitySet');
      var request;

      if (entitySet && options.edm && (0, _primitiveUtilities.get)(entitySet, 'navigation.source.type') instanceof options.edm.types.ActionType) {
        request = _httpUtil.odata.post(url.queryify(_odataConverter.odataUri.convert({
          definition: definition,
          options: options,
          isFinding: true,
          entitySet: entitySet
        }), this.convertQuery(_underscore.default.extend({
          filterOptions: filterOptions
        }, params)), options.ajaxOptions.customParameterizationFunc), _underscore.default.defaults({
          data: entitySet.navigation.parameters
        }, getCommonOptions(options)));
        options.cacheResponse = false;
      } else {
        request = _httpUtil.odata.get(_odataConverter.odataUri.convert({
          definition: definition,
          options: options,
          isFinding: true,
          entitySet: entitySet
        }), _underscore.default.defaults({
          data: this.convertQuery(_underscore.default.extend({
            filterOptions: filterOptions
          }, params))
        }, getCommonOptions(options)));
      }

      return request.then(function (res) {
        if (!res) {
          return null;
        }

        var addPropertyTotalCount = function addPropertyTotalCount(obj) {
          return Object.defineProperty(obj, 'totalCount', {
            value: res['@odata.count'],
            enumerable: false
          });
        };

        var addPropertyRaw = function addPropertyRaw(obj) {
          return Object.defineProperty(obj, 'raw', {
            value: res,
            enumerable: false
          });
        };

        var queryId = _underscore.default.uniqueId('query-'); // if OData results is just an array of string, make it an object then assign the object to value.


        if (_underscore.default.isString(_underscore.default.first(res.value))) {
          res.value = _underscore.default.map(res.value, function (item) {
            return {
              id: _underscore.default.uniqueId('item-'),
              value: item
            };
          });
        } // JSData requires ID for every resource
        // Some calls to OData server won't return items with ID, or return items with an empty string as id
        // We add ID here to fit JSData requirement before JSData inject happens


        _underscore.default.each(res.value, function (item, index) {
          if (!_underscore.default.has(item, definition.idAttribute) || item[definition.idAttribute] === '') {
            item[definition.idAttribute] = "".concat(queryId, "-").concat(index);
          }
        });

        var addProperties = _underscore.default.compose(addPropertyTotalCount, addPropertyRaw);

        if (options.cacheResponse) {
          options.afterInject = _underscore.default.compose(options.afterInject || _underscore.default.identity, function (innerOptions, injected) {
            return addProperties(injected);
          });
        } else {
          // if odata response payload is not wrapped in value property,
          // move the contents under res.value
          res.value = _underscore.default.has(res, 'value') ? res.value : res;
          addProperties(res.value);
        }

        return res.value;
      }, function (res) {
        //in case of error, it returns statusText for caller
        return res.statusText;
      });
    }
  }, {
    key: "update",
    value: function update(definition, id, attrs, options) {
      _underscore.default.extendOwn(options, this.options);

      var data = _odataConverter.odataCast.data({
        data: attrs,
        definition: definition,
        options: options
      });

      return _httpUtil.odata.patch(_odataConverter.odataUri.convert({
        definition: definition,
        options: options,
        id: id
      }), // NOTICE: modified to replace app state/config
      _underscore.default.defaults({
        data: data
      }, getCommonOptions(options)));
    }
  }, {
    key: "updateAll",
    value: function updateAll(definition, attrs, params, options) {
      _underscore.default.extendOwn(options, this.options); // Must resolve the promise with the updated items


      return sendBatchRequest(definition, params.reqs, options);
    }
  }, {
    key: "destroy",
    value: function destroy(definition, id, options) {
      _underscore.default.extendOwn(options, this.options); // Must return a promise


      return _httpUtil.odata.delete(_odataConverter.odataUri.convert({
        definition: definition,
        options: options,
        id: id
      }), getCommonOptions(options)).then(_underscore.default.property('value'));
    }
  }, {
    key: "destroyAll",
    value: function destroyAll(definition, params, options) {
      _underscore.default.extendOwn(options, this.options);

      return sendBatchRequest(definition, params.reqs, options);
    }
  }]);

  return ODataBaseAdapter;
}();

exports.ODataBaseAdapter = ODataBaseAdapter;

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__40__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
